import { render, staticRenderFns } from "./NoLeakFound.vue?vue&type=template&id=2bf1911d&scoped=true"
import script from "./NoLeakFound.vue?vue&type=script&lang=js"
export * from "./NoLeakFound.vue?vue&type=script&lang=js"
import style0 from "./NoLeakFound.vue?vue&type=style&index=0&id=2bf1911d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf1911d",
  null
  
)

export default component.exports